<template>
  <div v-if="post">
    <div
      class="post-card-wrap shadow-and-scale"
      :class="{'pb-5r': showAuthor}"
    >
      <span
        class="post-card-image"
        :style="{ backgroundImage: `url('${post.picture|| 'https://picsum.photos/id/1049/3900/3120'}')` }"
      ></span>
      <div class="post-card-header">
        <span v-if="post.specialties" class="post-card-specialty">{{post.specialties[0]}}</span>
        <div class="post-card-time">
          <span class="icon">
            <i class="mdi mdi-clock"></i>
          </span>
          {{post.updatedOn||post.createdOn | formatDate}}
        </div>
      </div>
      <div class="post-card-main">
        <h2 class="post-card-title">{{post.title}}</h2>
        <p class="post-card-snippet">{{post.content | trimLength(50) }}</p>
        <span class="post-card-cta">
          <router-link
            :to="`/posts/${post.id}`"
            class="button is-primary"
          >Leia mais</router-link>
        </span>

      </div>

      <div
        class="post-card-footer"
        v-if="showAuthor"
      >
        <span
          class="post-author-pic"
          :style="{backgroundImage: `url('${post.author.picture || `https://ui-avatars.com/api/?size=512&background=386B61&color=fff&name=${post.author.name}+${post.author.lastName}`} ')` }"
        >
        </span>
        <span class="post-author-name">
          <router-link
                  :to="`/profiles/${post.userId}`"
                  class="hover:underline"
          >
            {{post.author.name}} {{post.author.lastName || ''}}
          </router-link>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDateMixin, trimLengthMixin } from '../../mixins/filters'
export default {
  mixins: [formatDateMixin, trimLengthMixin],
  props: {
    post: {
      type: Object,
      required: true
    },
    showAuthor: {
      type: Boolean
    }
  },
  mounted () {
    console.log('BlogPostCard Post', this.post)
  }

}
</script>
